import { DownloadOutlined, PlusOutlined, PrinterOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Space, Table } from "antd";
import Column from "antd/es/table/Column";
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { trangThaiTongHopDangKyDaoTao, urlAdmin } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, shortFileName } from '../../helpers/common';
import { layChiTietDangKyDaoTaoNam, layDsTongHopDangKyDaoTao, xuatKeHoachDaoTaoNam, xuatPhieuTrinhDaoTaoNam } from '../../services/daotao';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import InDangKyDaoTaoNam from './InDangKyDaoTaoNam';
import TrangThaiTongHopTag from './TrangThaiTongHopTag';

const TongHopDangKy = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const [dataTable, setDataTable] = useState<Array<any>>();
    const menu: any = menuHelper.checkMultiPermission([Links.DangKyDaoTao.ChiTiet]);
    const [data, setData] = useState<any>(null);

    const layDuLieu = async () => {
        setIsLoading(true);
        try {
            var res = await layDsTongHopDangKyDaoTao();
            setDataTable((res || []).map((v: any) => { return { ...v, key: v.id } }));
        } catch (error: any) {
            toast.error(error.message);
        }
        setIsLoading(false);
    };

    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [exportId, setExportId] = useState<number | null>(null);
    const [exportForm] = Form.useForm();

    const handleOpenExportModal = (record: any) => {
        setExportId(record.id);
        exportForm.setFieldsValue({
            soVanBan: record.soVanBan || '',
            maVanBan: 'KH-QĐTPT',
            ngayKyVanBan: record.ngayKyVanBan != null ? dayjs(record.ngayKyVanBan) : null,
        });
        setIsExportModalVisible(true);
    };

    const handleDownloadWord = async () => {
        try {
            const values = await exportForm.validateFields();
            if (exportId) {
                dispatch(showLoadingScreen());
                const response = await xuatKeHoachDaoTaoNam(exportId, values.soVanBan || '', values.maVanBan || '', values.ngayKyVanBan || null);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `KeHoachDaoTao.docx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                dispatch(hideLoadingScreen());
                setIsExportModalVisible(false);
            }
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error("Tải file không thành công");
        }
    }

    const handleDownloadPhieuTrinh = async (record: any) => {
        try {
            if (record?.id) {
                dispatch(showLoadingScreen());
                const response = await xuatPhieuTrinhDaoTaoNam(record.id);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `PhieuTrinhKeHoachDaoTao_${record.nam ? dayjs(record.nam).format('YYYY') : ''}.docx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                dispatch(hideLoadingScreen());
            }
        } catch (error: any) {
            dispatch(hideLoadingScreen());
            toast.error("Tải file không thành công");
        }
    };

    const layCTDangKyDaoTaoNam = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            if (id > 0) {
                var detailData = await layChiTietDangKyDaoTaoNam(id);
                setData(detailData);
                dispatch(hideLoadingScreen());
            }
        }
        catch (error: any) {
            toast.error("Đợt đăng ký đào tạo không tồn tại!");
            dispatch(hideLoadingScreen());
        }
    }
    const componentRef = useRef(null);
    const printDangKyDaoTaoNam = useReactToPrint({
        content: () => {
            return componentRef.current
        },
    });
    useEffect(() => {
        if (!data) return;
        setTimeout(() => {
            printDangKyDaoTaoNam();
        }, 300);
    }, [data])
    useEffect(() => {
        layDuLieu();
    }, []);

    return (
        <section>
            <ContentHeader title="Tổng hợp đăng ký đào tạo" />
            <Row className="mb-2">
                <Col span="24">
                    {
                        menu[Links.DangKyDaoTao.ChiTiet] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.DangKyDaoTao.ChiTiet}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            rowKey="id"
                            dataSource={dataTable}
                            pagination={{
                                defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'],
                                current: page, onChange: (page) => { setPage(page); }
                            }}
                            loading={isLoading}
                            bordered
                            scroll={{ x: 'max-content' }}
                        >
                            <Column title="STT" width="55px" align="center" render={(value, record, index) => { return <span key={index}>{index + 1 + (page - 1) * 10}</span> }} />
                            <Column title="Tên đợt đăng ký" dataIndex="ten" key="ten" />
                            <Column title="Năm" dataIndex="nam" key="nam" align="center"
                            render={(value, record, index) => {
                                return (
                                    <span key={"ngayBatDau" + index}>
                                        {dateCommon.formatDate(record.nam, "yyyy")}
                                    </span>
                                );
                            }}
                            />
                            <Column
                                title="Thời gian đăng ký"
                                key="ngayBatDau"
                                width={"210px"} align="center"
                                render={(value, record, index) =>
                                (<span key={"ngayBatDau" + index}>
                                    {dateCommon.formatDate(value?.ngayBatDau)} - {dateCommon.formatDate(value?.ngayKetThuc)}
                                </span>
                                )
                                }
                            />
                            <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                return <TrangThaiTongHopTag value={record.trangThai} />
                            }} />
                            <Column title="Số quyết định" dataIndex="soVanBan" key="soVanBan"
                                render={(value, record) => record.trangThai == trangThaiTongHopDangKyDaoTao.banHanh? `${record.soVanBan}/${record.maVanBan}` : ""}
                            />
                            <Column
                                title="File ban hành"
                                dataIndex="taiLieuBanHanh"
                                key="taiLieuBanHanh"
                                align="center"
                                render={(taiLieuBanHanh) => (
                                    <>
                                        {(taiLieuBanHanh || []).map((file, index) => (
                                            <span key={index} style={{ marginRight: "5px" }}>
                                                <a
                                                    href={urlAdmin + file.duongDan?.replace(/\\/g, "/")}
                                                    download={file.tenTep}
                                                >
                                                    <Button
                                                        className="hrm-btn hrm-btn-sm hrm-btn-success"
                                                        title={file.tenTep}
                                                    >
                                                        <i className="fa fa-download mr-2" />
                                                        {shortFileName(file.tenTep)}
                                                    </Button>
                                                </a>
                                            </span>
                                        ))}
                                    </>
                                )}
                            />
                            <Column title="" align="center" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return <Space>
                                    <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.DangKyDaoTao.Xem + "?tab=2&id=" + record.id}>Xem</Link>
                                    {record.noiDung != null && <>
                                        <Button
                                            className="hrm-btn-print"
                                            size="small"
                                            icon=<PrinterOutlined rev="" />
                                            onClick={() => { layCTDangKyDaoTaoNam(record.id) }}
                                        >In phiếu trình
                                        </Button>
                                        <Button
                                            type="primary"
                                            size="small"
                                            icon=<DownloadOutlined rev="" />
                                            onClick={() => { handleDownloadPhieuTrinh(record) }}
                                        >Tải phiếu trình
                                        </Button>
                                    </>}
                                    {record.trangThai >= trangThaiTongHopDangKyDaoTao.trinhPhoCVP && record.trangThai < trangThaiTongHopDangKyDaoTao.banHanh && <Button
                                        type="primary"
                                        size="small"
                                        icon=<DownloadOutlined rev="" />
                                        onClick={() => { handleOpenExportModal(record) }}
                                    >Tải Kế hoạch
                                    </Button>}
                                </Space>
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
            {data != null &&
                <section style={{ display: 'none' }}>
                    <div ref={componentRef} >
                        <InDangKyDaoTaoNam data={data} ></InDangKyDaoTaoNam>
                    </div>
                </section>
            }
            <Modal
                title="Xuất file Kế hoạch đào tạo"
                open={isExportModalVisible}
                onOk={handleDownloadWord}
                onCancel={() => setIsExportModalVisible(false)}
                okText="Xuất file"
                cancelText="Hủy"
            >
                <Form form={exportForm} layout="vertical">
                    <Form.Item label="Số văn bản" name="soVanBan">
                        <Input placeholder="Nhập số văn bản (nếu có)" />
                    </Form.Item>
                    <Form.Item label="Mã văn bản" name="maVanBan">
                        <Input placeholder="Nhập mã văn bản" />
                    </Form.Item>
                    <Form.Item label="Ngày ký văn bản" name="ngayKyVanBan">
                        <DatePicker changeOnBlur={true} placeholder="Nhập ngày ký văn bản (nếu có)" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}  />
                    </Form.Item>
                </Form>
            </Modal>
        </section>
    );
};

export default TongHopDangKy;